export default {
	controls: {
		next: "Suivant",
		prev: "Précédent",
		done: "Terminer",
		progressSeparator: "sur",
	},
	welcome: {
		title: "Bienvenue sur ORI !",
		description: "ORI est un système de gestion spirituelle pour les temples. Faisons une visite guidée rapide des modules du système afin que vous puissiez découvrir tout ce qui est disponible.",
		recommended: "Fortement recommandé",
		start: "Commencer la visite guidée",
		skip: "Passer pour le moment",
	},
	helpPanel: {
		title: "Aide de la page",
		rewatchTour: "Revoir la visite guidée",
	},
	guided: {
		assistant: {
			title: "Assistant virtuel",
			description: "Et chaque fois que vous avez besoin d'aide, parlez à l'assistant. Il répond aux questions, vous montre où cliquer et vous aide à configurer le temple étape par étape — cliquez simplement sur ce bouton à tout moment.",
		},
		dashboard: {
			title: "Tableau de bord",
			description: "La page d'accueil du système. Vous y voyez un résumé rapide : vos données, le rituel actif, ceux programmés, des graphiques rapides et les anniversaires du jour.",
		},
		consultants: {
			title: "Consultants",
			description: "Personnes qui visitent le temple pour recevoir des soins spirituels. Inscrivez, recherchez et gérez tous les consultants.",
		},
		mediums: {
			title: "Médiums",
			description: "Membres du corps médiumnique du temple. Gérez les inscriptions des médiums, les rôles et les lignes spirituelles. Ajoutez un parcours à un consultant pour l'intégrer à la chaîne spirituelle.",
		},
		journeyStages: {
			title: "Étapes du parcours",
			description: "Étapes par lesquelles une personne passe au temple (ex. : Visiteur, Initié, Développé). Chaque personne peut se trouver à une étape spécifique.",
		},
		functions: {
			title: "Fonctions",
			description: "Rôles que les médiums exercent lors des rituels (ex. : Cambono, Ogã, Pai/Mãe de Santo). Attribuez des fonctions aux personnes.",
		},
		memberGroups: {
			title: "Groupes",
			description: "Organisez les personnes en groupes pour faciliter la gestion. Créez des groupes par objectif (ex. : Groupe d'étude, Chaîne de guérison) et attribuez des membres.",
		},
		spiritualLines: {
			title: "Lignes spirituelles",
			description: "Lignes spirituelles qui travaillent dans la maison. Ex. : Ligne des Pretos Velhos, Ligne des Caboclos, Ligne des Enfants.",
		},
		guides: {
			title: "Guides spirituels",
			description: "Entités qui servent les personnes au temple. Enregistrez des guides et associez-les aux personnes pour maintenir les registres spirituels.",
		},
		orixas: {
			title: "Orixás",
			description: "Divinités vénérées au temple. Enregistrez des orixás et associez-les aux personnes pour enregistrer leur couronne spirituelle et leurs connexions.",
		},
		attendanceTypes: {
			title: "Types de tickets",
			description: "Catégories de présence disponibles (ex. : Consultation, Passe, Nettoyage). Créez-les selon les besoins de votre maison. Ces tickets sont ensuite associés aux rituels.",
		},
		ritualTypes: {
			title: "Types de rituels",
			description: "Catégories de rituels pratiqués au temple (ex. : Gira de Caboclo, Séance de guérison). Chaque rituel créé est associé à un type.",
		},
		rituals: {
			title: "Rituels",
			description: "Rituels organisés au temple. Créez, démarrez, gérez et clôturez des rituels. Chaque rituel génère des tickets, des appels et des registres de présence.",
		},
		financialDashboard: {
			title: "Finances",
			description: "Tableau de bord financier du temple. Suivez les revenus, les dépenses et le solde global. Vue consolidée de tous les mouvements financiers.",
		},
		financialFunds: {
			title: "Fonds",
			description: "Gérez les fonds du temple. Créez des fonds, enregistrez des contributions et suivez les mouvements de revenus.",
		},
		financialMovements: {
			title: "Mouvements",
			description: "Historique complet de tous les mouvements financiers du temple. Filtrez par période, fonds, type et statut.",
		},
		financialReports: {
			title: "Rapports financiers",
			description: "Rapports détaillés sur la situation financière. Clôtures mensuelles, bilans et analyses par période.",
		},
		templeSettings: {
			title: "Paramètres du temple",
			description: "Modifiez les données du temple, le contact, l'adresse, les horaires et l'identité visuelle. Configurez l'impression, l'e-mail, la présence et les paramètres financiers.",
		},
		templeUsers: {
			title: "Utilisateurs",
			description: "Consultez qui a accès au système, leurs rôles (Propriétaire, Admin, Membre) et le statut d'activité.",
		},
		templeInvites: {
			title: "Invitations",
			description: "Envoyez des invitations par e-mail pour que de nouvelles personnes accèdent au système. Suivez le statut de chaque invitation.",
		},
		wisdomQuotes: {
			title: "Citations de sagesse",
			description: "Gérez les citations de sagesse affichées sur le tableau de bord et les messages du temple. Ajoutez, modifiez ou désactivez des citations.",
		},
		billing: {
			title: "Plan et abonnement",
			description: "Consultez le plan actuel du temple, la période d'essai et les informations d'abonnement.",
		},
		displayMessages: {
			title: "Messages d'affichage",
			description: "Gérez les messages affichés sur ORI TV. Créez des avis, des rappels et des annonces pour l'écran du temple.",
		},
		import: {
			title: "Importation",
			description: "Importez des données en masse dans le système. Téléchargez des feuilles de calcul avec les dossiers des personnes pour accélérer la migration.",
		},
		support: {
			title: "Support",
			description: "Canal direct avec l'équipe ORI. Ouvrez des tickets pour des questions, des suggestions ou des problèmes techniques et suivez leur statut.",
		},
	},
	pages: {
		Dashboard: "Le tableau de bord est la page d'accueil du système. Vous y voyez un résumé rapide : vos données, le rituel actif, ceux programmés, des graphiques rapides et les anniversaires du jour.",
		Consultants: "Les consultants sont des personnes qui visitent le temple pour recevoir des soins spirituels. Ici, vous inscrivez, recherchez et gérez tous les consultants.",
		Mediums: "Les médiums sont les membres du corps médiumnique du temple. Ici, vous gérez toutes les inscriptions des médiums, y compris les rôles et les lignes spirituelles. Ajoutez un parcours à un consultant pour l'intégrer à la chaîne spirituelle.",
		SpiritualLines: "Lignes spirituelles qui travaillent dans la maison. Ex. : Ligne des Pretos Velhos, Ligne des Caboclos, Ligne des Enfants.",
		Guides: "Les guides spirituels sont des entités qui servent les personnes au temple. Enregistrez des guides et associez-les aux personnes pour maintenir les registres spirituels.",
		Orixas: "Les orixás sont des divinités vénérées au temple. Enregistrez des orixás et associez-les aux personnes pour enregistrer leur couronne spirituelle et leurs connexions.",
		RitualTypes: "Les types de rituels définissent les catégories de rituels pratiqués au temple. Chaque rituel créé est associé à un type.",
		Rituals: "Rituels organisés au temple. Ici, vous créez, démarrez, gérez et clôturez des rituels. Chaque rituel génère des tickets, des appels et des registres de présence.",
		JourneyStages: "Les étapes du parcours représentent les étapes par lesquelles une personne passe au temple. Chaque personne peut se trouver à une étape spécifique.",
		Functions: "Les fonctions définissent les rôles que les médiums exercent lors des rituels. Attribuez des fonctions aux personnes pour organiser le corps médiumnique.",
		MemberGroups: "Les groupes vous permettent d'organiser les personnes par objectif. Créez des groupes, ajoutez des membres et gérez les attributions collectives.",
		AttendanceTypes: "Catégories de présence disponibles (ex. : Consultation, Passe, Nettoyage). Créez-les selon les besoins de votre maison. Ces tickets sont ensuite associés aux rituels.",
		FinancialDashboard: "Tableau de bord financier du temple. Suivez les revenus, les dépenses et le solde global. Vue consolidée de tous les mouvements financiers.",
		FinancialFunds: "Gérez les fonds du temple. Créez des fonds, enregistrez des contributions et suivez les mouvements de revenus.",
		FinancialMovements: "Historique complet de tous les mouvements financiers du temple. Filtrez par période, fonds, type et statut.",
		FinancialReports: "Rapports détaillés sur la situation financière. Clôtures mensuelles, bilans et analyses par période.",
		TempleSettings: "Les paramètres du temple vous permettent de modifier les données, le contact, l'adresse, les horaires et l'identité visuelle. Configurez l'impression, l'e-mail, la présence et les paramètres financiers.",
		TempleUsers: "Gestion des utilisateurs du temple. Consultez qui a accès au système, leurs rôles et le statut d'activité.",
		TempleInvites: "Système d'invitation du temple. Envoyez des invitations par e-mail pour que de nouvelles personnes accèdent au système.",
		WisdomQuotes: "Citations de sagesse affichées sur le tableau de bord et les messages du temple. Ajoutez, modifiez ou désactivez des citations.",
		Billing: "Consultez le plan actuel du temple, la période d'essai et les informations d'abonnement.",
		DisplayMessages: "Gérez les messages affichés sur ORI TV. Créez des avis, des rappels et des annonces pour l'écran du temple.",
		Import: "Importez des données en masse dans le système. Téléchargez des feuilles de calcul avec les dossiers des personnes pour accélérer la migration.",
		Support: "Canal direct avec l'équipe ORI. Ouvrez des tickets pour des questions, des suggestions ou des problèmes techniques et suivez leur statut.",
	},
};
